<template>
  <div>
    <!-- 提报人信息 -->
    <div class="trade-order-block">
      <div class="block-title">提报人信息</div>
      <div class="block-content">
        <el-row v-if="tradeApplyOrderVO.tradeApplyInfoVO" class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">提报人</el-col>
          <el-col :span="9">{{ tradeApplyOrderVO.tradeApplyInfoVO.applyClientName}}</el-col>

          <!-- 所属区域 -->
          <el-col :span="3">所属区域</el-col>
          <el-col :span="9">{{tradeApplyOrderVO.tradeApplyInfoVO.applyClientRegionName }}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 冰柜信息 -->
    <div class="trade-order-block" v-if="entryCode == '113' ">
      <div class="block-title">冰柜信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">冰柜名称</el-col>
          <el-col :span="9">{{coolerInfo.coolerItemName}}</el-col>

          <el-col :span="3">经销商名称</el-col>
          <el-col :span="9">{{ coolerInfo.wholesalerInfo.wholesalerName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">冰柜资产编码</el-col>
          <el-col :span="9">{{ coolerInfo.coolerAssetCode}}</el-col>

          <el-col :span="3">经销商仓库地址</el-col>
          <el-col :span="9">{{ coolerInfo.warehouseInfo.detailAddress }}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 冰柜信息 -->
    <div class="trade-order-block" v-if="entryCode == '111' || entryCode == '112'">
      <div class="block-title">冰柜信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">冰柜名称</el-col>
          <el-col :span="9">{{coolerInfo.coolerItemName}}</el-col>
          <template v-if="isCash">
            <el-col :span="3" class="color-red">押金退还人</el-col>
            <el-col :span="9" class="color-red">{{ coolerInfo.paidContactPerson }}</el-col>
          </template>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">冰柜资产编码</el-col>
          <el-col :span="9">{{ coolerInfo.coolerAssetCode}}</el-col>
          <template v-if="isCash">
            <el-col :span="3" class="color-red">手机号</el-col>
            <el-col :span="9" class="color-red">{{ coolerInfo.paidContactPhone }}</el-col>
          </template>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店名称</el-col>
          <el-col :span="9">{{ coolerInfo.beforePocInfo.pocName}}</el-col>
          <template v-if="isCash">
            <el-col :span="3" class="color-red">待退还押金</el-col>
            <el-col :span="9" class="color-red">{{ coolerInfo.pledgeAmount }}</el-col>
          </template>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店地址</el-col>
          <el-col :span="9">{{coolerInfo.beforePocInfo.detailAddress }}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 投放门店 -->
    <!-- 转入门店 -->
    <div class="trade-order-block" v-if="entryCode == '111' || entryCode == '113' ">
      <div class="block-title" v-if="entryCode == '113' ">投放门店</div>
      <div class="block-title" v-if="entryCode == '111' ">转入门店</div>
      <div
        class="block-content"
        v-if="['105', '102', '111','112','113','201','302','303'].includes(tradeApplyOrderVO.tradeApplyExecVO.execTypeSub) && tradeApplyBaseVO.abiOneId"
      >
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocName" label="门店名称" />
          <BaseCell :value="basePocInfo.abiOneId" label="IGnite ID" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.channelName" label="门店渠道" />
          <BaseCell :value="basePocInfo.abiChannelFormat" label="渠道业态" />
        </el-row>
        <el-row class="content-row">
          <BaseCell
            :value="`${tradeApplyOrderVO.tradeApplyBaseVO.wccsId || ''}  ${tradeApplyOrderVO.tradeApplyBaseVO.wccsWsName ? (tradeApplyOrderVO.tradeApplyBaseVO.wccsWsName) : ''}`"
            label="WCCSID"
          />
          <BaseCell :value="isPbo" label="是否ABI买店" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.businessChannelName" label="业务渠道" />
          <BaseCell :value="basePocInfo.wccsSalesPotentialCode2022VersionName" label="销售潜力" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="tradeApplyBaseVO.keyContactPerson" :label="`收货人姓名`" />
          <BaseCell :value="tradeApplyBaseVO.keyContactPhone" :label="`收货人电话`" />
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门头照</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="store-info-img">
            <!-- 未开业-->
            <img
              v-if="basePocInfo.abiValidationStatus == 0 && basePocInfo.abiValidationType == 3"
              mode="aspectFit"
              class="detail-row-img"
              src="@/assets/images/poc_photo_default.png"
            />
            <img
              v-else-if="basePocInfo.pocOutsidePhotoUri"
              mode="aspectFill"
              class="detail-row-img"
              :src="getImg(basePocInfo.pocOutsidePhotoUri)"
            />
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店照片</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="store-info-img">
            <div v-if="pocImageList.length">
              <div class="img-wrapper" v-for="img in pocImageList" :key="img.title">
                <img :src="getImg(img.imageUri)" />
                <div class="img-wrapper-title">{{ img.title }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">营业执照</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="store-info-img">
            <!-- 已验证 -->
            <template v-if="basePocInfo.abiValidationStatus == 1">
              <img
                class="detail-row-img"
                v-if="basePocInfo.bizLicensePhotoUri"
                mode="aspectFill"
                :src="getImg(basePocInfo.bizLicensePhotoUri)"
              />
              <!-- full -->
              <div
                v-else-if="basePocInfo.abiValidationType == 3 && basePocInfo.businessLicensePicNotReason"
              >{{ basePocInfo.businessLicensePicNotReason || '暂无' }}</div>
              <!-- basic -->
              <div v-else>暂无</div>
            </template>
            <!-- 未开业 -->
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">补充资料</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img__row">
            <template v-if="basePocInfo.pocImageList && basePocInfo.pocImageList.length">
              <div class="img-wrapper" v-for="img in basePocInfo.pocImageList" :key="img.pocImageId">
                <img :src="getImg(img.imageUri)" />
              </div>
            </template>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <BaseCell
            :value="`${basePocInfo.provinceName || ''} ${basePocInfo.cityName || ''} ${basePocInfo.countyName || ''} ${basePocInfo.detailAddress || ''}`"
            label="门店地址"
            allCell
          />
        </el-row>
        <div class="block-content">
          <el-row class="content-row">
            <div id="content-map"></div>
          </el-row>
        </div>
      </div>
      <div class="block-content" v-else>
        <el-row class="content-row">
          <el-col :span="3">门店名称</el-col>
          <el-col :span="9">{{ basePocInfo.pocName }}</el-col>

          <el-col :span="3">业务渠道</el-col>
          <el-col :span="9">{{ basePocInfo.businessChannelName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店联系人</el-col>
          <el-col :span="9">{{basePocInfo.keyContactPerson}}</el-col>

          <el-col :span="3">地理位置</el-col>
          <el-col :span="9">{{ basePocInfo.pocLocalName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">联系人手机号</el-col>
          <el-col :span="9">{{ basePocInfo.keyContactPhone}}</el-col>

          <el-col :span="3">门店特征</el-col>
          <el-col :span="9">{{ basePocInfo.pocAreaName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">渠道</el-col>
          <el-col :span="9">{{ basePocInfo.channelName}}</el-col>

          <el-col :span="3">人均消费</el-col>
          <el-col :span="9">{{ basePocInfo.averageFee }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">子渠道</el-col>
          <el-col :span="9">{{ basePocInfo.subChannelName}}</el-col>

          <el-col :span="3">WCCSID</el-col>
          <el-col :span="9">{{ tradeApplyOrderVO.tradeApplyBaseVO.wccsId }}</el-col>
        </el-row>
        <div class="block-content">
          <el-row class="content-row">
            <div id="content-map"></div>
          </el-row>
        </div>
      </div>
    </div>
    <StoreStandard :execTypeSub="entryCode" :tradeApplyOrderPocCheckInfo="tradeApplyOrderVO.tradeApplyOrderPocCheckInfo"></StoreStandard>
    <!-- 回库信息 -->
    <div class="trade-order-block" v-if="entryCode == '112'">
      <div class="block-title">回库信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">回库经销商</el-col>
          <el-col :span="9">{{coolerInfo.wholesalerInfo.wholesalerName }}</el-col>

          <!-- 所属区域 -->
          <el-col :span="3">回库地址</el-col>
          <el-col :span="9">{{ coolerInfo.warehouseInfo ? coolerInfo.warehouseInfo.detailAddress : ''}}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 补充说明 -->
    <div class="trade-order-block">
      <div class="block-title" v-if="entryCode == '111' ">转店说明</div>
      <div class="block-title" v-if="entryCode == '112' ">回库说明</div>
      <div class="block-title" v-if="entryCode == '113' ">补充说明</div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3" v-if="entryCode == '111' ">转店原因</el-col>
          <el-col :span="3" v-if="entryCode == '112' ">回库原因</el-col>
          <el-col :span="9" v-if="entryCode != '113' ">{{ coolerInfo.applyReason}}</el-col>

          <el-col :span="3">补充说明</el-col>
          <el-col :span="9">{{ coolerInfo.applyDesc}}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 冰柜验证 -->
    <div v-if="tradeApplyOrderVO.tradeApplyExecCoolerTrackVO" class="trade-order-block">
      <div class="block-title">冰柜验证</div>
      <div class="block-content">
        <el-row class="content-row">
          <template v-if="tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.qrCodePhotoUri">
            <el-col :span="3">冰柜资产牌照片</el-col>
            <el-col :span="9" v-viewer="{movable: true}">
              <img :src="getImg(tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.qrCodePhotoUri)" class="info-img" />
            </el-col>
          </template>
          <el-col :span="3">资产牌验证结果</el-col>
          <el-col :span="9" style="color:red;">{{ verifyStatus }}</el-col>
        </el-row>

        <el-row class="content-row">
          <el-col :span="3">冰柜正面照片</el-col>
          <el-col :span="9" v-viewer="{movable: true}">
            <img :src="getImg(tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.frontPhotoUri)" class="info-img" />
          </el-col>
        </el-row>

        <el-row class="content-row">
          <el-col :span="3">冰柜侧面照片</el-col>
          <el-col :span="9" v-viewer="{movable: true}">
            <img :src="getImg(tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.sidePhotoUri)" class="info-img" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from "@/utils/common"
import BaseCell from '@/components/base-cell'
import StoreStandard from "./store-standard.vue"
export default {
  name: "store-base-info",
  components: {
    BaseCell,
    StoreStandard
  },
  props: {
    tradeApplyOrderVO: {
      type: Object,
      default: () => { }
    },
    tradeApplyBaseVO: {
      type: Object,
      default: () => { }
    },
    coolerInfo: {
      type: Object,
      default: () => { }
    },
    afterPocInfo: {
      type: Object,
      default: () => { }
    },
    entryCode: {
      type: String,
      default: ""
    },
    basePocInfo: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    isCash () {
      return Number(this.coolerInfo.pledgeAmount) > 0
    },
    /* coolerInfo() {
      return this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO;
    },
    afterPocInfo() {
      return this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.afterPocInfo;
    }, */
    // 扫码验证状态
    verifyStatus () {
      const obj = {
        1: "验证成功",
        2: "验证失败",
        3: "未验证"
      }
      return obj[
        this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.qrCodeResult
      ]
    },
    isPbo () {
      if (this.basePocInfo.isPbo === null) return this.basePocInfo.isPbo
      return this.basePocInfo.isPbo ? '是' : '否'
    }
  },
  data () {
    return {
      pocImageList: []
    }
  },
  /* mounted() {
    console.log("------------------------------------参数");
    console.log(this.afterPocInfo);
     console.log(this.coolerInfo);
  }, */
  methods: {
    initMap (info) {
      this.pocImageList = []
      // 售点照片
      // if (this.afterPocInfo.pocOutsidePhotoUri) {
      //   this.pocImageList.push({ title: '门头照', imageUri: info.pocOutsidePhotoUri })
      // }
      if (this.basePocInfo.pocExternalPhotoUri) {
        this.pocImageList.push({ title: '外部整体', imageUri: info.pocExternalPhotoUri })
      }
      if (this.basePocInfo.pocInsidePhotoUri) {
        this.pocImageList.push({ title: '内部整体', imageUri: info.pocInsidePhotoUri })
      }
      if (this.basePocInfo.pocStreetPhotoUri) {
        this.pocImageList.push({ title: '外部街区', imageUri: info.pocStreetPhotoUri })
      }



      const { locLatitude, locLongitude, pocName } = info
      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },
    setClientType (val) {
      if (val === "01") return "TMKT"
      if (val === "02") return "ISP"
      if (val === "03") return "KA"
      return ""
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
};
</script>

<style lang="scss" scoped>
.color-red {
  color: $base-red;
}
#content-map {
  width: 450px;
  height: 200px;
  border-radius: 8px;
  cursor: pointer;
}

.info-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}
.store-info-img {
  img {
    width: 200px;
    height: 130px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}
.img-wrapper {
  padding-right: 8px;
  padding-bottom: 8px;
}
.info-img__row {
  display: flex;
  flex-wrap: wrap;
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}
</style>
